export const CONTENT_PADDING_X = { lg: 123, md: 88, base: 30 };
export const SECTION_SPACING = { lg: '100px', md: '75px', base: '50px' };
